import React from 'react';
// Link importieren
import { Navigate, Link } from 'react-router-dom';
import styled from 'styled-components';
// theme importieren, falls noch nicht geschehen
import { theme } from '../styles/theme';
import { useAuthStore } from '../store/authStore';
import LoginForm from '../components/auth/LoginForm'; // Sicherstellen, dass der Pfad korrekt ist

const LoginPage = () => {
  const { isAuthenticated, isLoading } = useAuthStore();

  // Redirect if already authenticated
  if (isAuthenticated && !isLoading) {
    return <Navigate to="/app" replace />; // replace hinzugefügt
  }

  return (
    <Container>
      <LoginBox>
        <Logo>Law-AI</Logo>
        <Subtitle></Subtitle>

        {isLoading ? (
          <LoadingText>Lädt...</LoadingText>
        ) : (
          <LoginForm />
        )}

        {/* NEU: Zusätzlicher Text und Links */}
        <FooterInfo>
          <CustomSolutionText>
            Für Anfragen kontaktieren
            Sie uns bitte unter:{' '}
            <a href="mailto:jk@phoenixconsulting.at">
              jk@phoenixconsulting.at
            </a>
          </CustomSolutionText>
          <LegalLinks>
            <StyledLink to="/impressum">Impressum</StyledLink>
            <Separator>|</Separator>
            <StyledLink to="/datenschutz">Datenschutzerklärung</StyledLink>
          </LegalLinks>
        </FooterInfo>
      </LoginBox>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 2rem;
  background-color: ${theme.colors.backgroundAlt};
`;

const LoginBox = styled.div`
  background-color: ${theme.colors.background};
  padding: 2.5rem 3rem;
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.boxShadow.lg};
  width: 100%;
  max-width: 450px; // Maximale Breite für die Box
  text-align: center;
`;

const Logo = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: ${theme.colors.primary};
`;

const Subtitle = styled.p`
  font-size: 1rem;
  color: ${theme.colors.textLight};
  margin-bottom: 2.5rem; // Mehr Abstand
`;

const LoadingText = styled.div`
  font-size: 1rem;
  color: ${theme.colors.textLight};
`;

// NEU: Container für Footer-Infos
const FooterInfo = styled.div`
  margin-top: 2.5rem; // Abstand nach oben
  padding-top: 1.5rem;
  border-top: 1px solid ${theme.colors.borderLight};
`;

// NEU: Styling für den Custom-Text
const CustomSolutionText = styled.p`
  font-size: 0.85rem;
  color: ${theme.colors.textLight};
  line-height: 1.5;
  margin-bottom: 1rem;

  a {
    color: ${theme.colors.primary};
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
`;

// NEU: Container für die rechtlichen Links
const LegalLinks = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem; // Abstand zwischen den Links
`;

// NEU: Styling für die Links
const StyledLink = styled(Link)`
  font-size: 0.8rem;
  color: ${theme.colors.textMuted}; // Dezente Farbe
  text-decoration: none;

  &:hover {
    color: ${theme.colors.primary};
    text-decoration: underline;
  }
`;

// NEU: Trennzeichen
const Separator = styled.span`
  font-size: 0.8rem;
  color: ${theme.colors.textMuted};
`;

export default LoginPage;
